import { render, staticRenderFns } from "./Packaging.vue?vue&type=template&id=9ce0eb1e&scoped=true"
import script from "./Packaging.vue?vue&type=script&lang=js"
export * from "./Packaging.vue?vue&type=script&lang=js"
import style0 from "./Packaging.vue?vue&type=style&index=0&id=9ce0eb1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce0eb1e",
  null
  
)

export default component.exports